// GET INVOICES
export const GET_INVOICES = 'GET_INVOICES';
export const GET_INVOICES_SUCCESS = 'GET_INVOICES_SUCCESS';
export const GET_INVOICES_FAILED = 'GET_INVOICES_FAILED';

// GET GLOBAL INVOICES
export const GET_GLOBAL_INVOICES = 'GET_GLOBAL_INVOICES';
export const GET_GLOBAL_INVOICES_SUCCESS = 'GET_GLOBAL_INVOICES_SUCCESS';
export const GET_GLOBAL_INVOICES_FAILED = 'GET_GLOBAL_INVOICES_FAILED';

// GET GLOBAL INVOICE DETAIL
export const GET_GLOBAL_INVOICE_DETAIL = 'GET_GLOBAL_INVOICE_DETAIL';
export const GET_GLOBAL_INVOICE_DETAIL_SUCCESS = 'GET_GLOBAL_INVOICE_DETAIL_SUCCESS';
export const GET_GLOBAL_INVOICE_DETAIL_FAILED = 'GET_GLOBAL_INVOICE_DETAIL_FAILED';
export const CLEANUP_GLOBAL_INVOICE_DETAIL = 'CLEANUP_GLOBAL_INVOICE_DETAIL';

// GET INVOICE DETAIL
export const GET_INVOICE_DETAIL = 'GET_INVOICE_DETAIL';
export const GET_INVOICE_DETAIL_SUCCESS = 'GET_INVOICE_DETAIL_SUCCESS';
export const GET_INVOICE_DETAIL_FAILED = 'GET_INVOICE_DETAIL_FAILED';

// PAY INVOICE
export const PAY_INVOICE = 'PAY_INVOICE';
export const PAY_INVOICE_SUCCESS = 'PAY_INVOICE_SUCCESS';
export const PAY_INVOICE_FAILED = 'PAY_INVOICE_FAILED';

// EXPORT INVOICE
export const EXPORT_INVOICE = 'EXPORT_INVOICE';
export const EXPORT_INVOICE_SUCCESS = 'EXPORT_INVOICE_SUCCESS';
export const EXPORT_INVOICE_FAILED = 'EXPORT_INVOICE_FAILED';
